import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import { withStyles } from "@material-ui/core/styles";
import { userActions } from '../../_actions';
import { apiConstants } from '../../_constants/api.constants';
import queryString from 'query-string';
import config from '../../config';

//-- CSS for Material
const styles = theme => ({
    error: {
        width: "auto",
        margin: "0 auto",
        background: "#ffbeba",
        padding: "10px 15px",
        marginTop: "50px",
        border: "2px solid #c71a0d",
        borderRadius: "9px",
        fontWeight: "bold"
    },     
    success: {
        width: "auto",
        margin: "0 auto",
        background: "#cbf5cb",
        padding: "10px 15px",
        marginTop: "50px",
        border: "2px solid green",
        borderRadius: "9px",
        fontWeight: "bold"
    },
    button : {
        display:" block",
        margin:" 0 auto",
        marginTop: "20px !important",
        border: "1px solid grey",
        borderRadius: "6px",
        background: "transparent",
        padding: "8px 11px",
        fontWeight: "bold",
    }
});

class StripeConnect extends Component {
    constructor(props) {
        super(props);
                
        this.state = {
            error : false,
            text : "We are processing you request to link stripe account with us."
        };
    }

    /*Rreact lifecycle method*/
    componentDidMount(){
        const { dispatch } = this.props;

        let params = queryString.parse(this.props.location.search);
        if(params.code == undefined || params.code == '' ){ this.setState({ error : true }) }
        else{
            let postData = {};
            postData.code = params.code;
    
            dispatch(userActions.stripeAccount(apiConstants.STRIPE_AUTHORIZE_ACCOUNT, postData ));
        }
    }

    //lifecycle method run when props change
    componentWillReceiveProps(props){
        if(props.updatedAccountDetails){            
            if( props.updatedAccountDetails.updatedAccountDetails !== undefined &&
                props.updatedAccountDetails.updatedAccountDetails.data !== undefined &&
                props.updatedAccountDetails.updatedAccountDetails.data.success == true){
                        this.setState({ error : false,text : "Account linked succesfully" })
                }else if( props.updatedAccountDetails.updatedAccountDetails == false){
                            this.setState({ error : true, text : "There is an error with your request" })
                    }else{ }
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <Fragment>
            <div id="wrapper">
                {
                    this.state.error ? 
                    <div class={classes.error+' container'} >{this.state.text}</div>
                    :
                    <div  class={classes.success+' container'}>{this.state.text}</div> 
                }
            </div>
            <input class={classes.button} type="button" onClick={(e)=>this.props.history.push('/login')} value="< Back To Dashborad"/>
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    //const { loggingIn } = state.authentication;
    const { language, updatedAccountDetails } = state;
    return {
        //loggingIn,
        language,
        updatedAccountDetails
    };
}

//-- We can collect all action methods under the bind creator and use "actions" as a globally on page.
// const mapDispatchToProps = dispatch => ({
//     actions: bindActionCreators(Object.assign({}, userActions), dispatch)
// });

const connectedLogin = connect(mapStateToProps)(withStyles(styles)(StripeConnect));
export { connectedLogin as StripeConnect };